var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovCoreLiftController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_91225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 536.602H853.393V658.779L780.204 610.404L673.861 655.677L566.264 610.403L473.058 696.61L372.342 725.14L327.928 688.548L292.897 635.831L259.742 667.462L185.926 606.062L134.63 613.505L77.08 564.509L2.63965 545.904L3.264 536.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 536.602V537.203H852.787V657.655L780.267 609.722L673.859 655.023L566.139 609.697L472.75 696.071L372.483 724.474L328.385 688.142L293.001 634.896L259.714 666.653L186.108 605.428L134.816 612.869L77.3663 563.961L3.27796 545.443L3.86903 536.642L3.26384 536.602V537.203V536.602L2.65865 536.562L2 546.364L76.7934 565.058L134.445 614.14L185.745 606.697L259.769 668.27L292.792 636.767L327.47 688.953L372.201 725.805L473.364 697.148L566.39 611.109L673.861 656.331L780.141 611.085L854 659.903V536H2.69597L2.65865 536.562L3.26384 536.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 536.602V537.203H852.787V657.655L780.267 609.722L673.859 655.023L566.139 609.697L472.75 696.071L372.483 724.474L328.385 688.142L293.001 634.896L259.714 666.653L186.108 605.428L134.816 612.869L77.3663 563.961L3.27796 545.443L3.86903 536.642L3.26384 536.602ZM3.26384 536.602V537.203V536.602ZM3.26384 536.602L2.65865 536.562L2 546.364L76.7934 565.058L134.445 614.14L185.745 606.697L259.769 668.27L292.792 636.767L327.47 688.953L372.201 725.805L473.364 697.148L566.39 611.109L673.861 656.331L780.141 611.085L854 659.903V536H2.69597L2.65865 536.562L3.26384 536.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 548V601.71V627.42V627.65V711.19H473.51H473.5V707.82V702.58V696.63V691.37V675.4V627.68V627.42",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 548V601.71V627.42V627.65V711.19H473.51H473.5V707.82V702.58V696.63V691.37V675.4V627.68V627.42",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.25 326.35L518.55 320.22L517.36 322.1L527.06 328.22L528.25 326.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.25 335.35L515.25 328.41L513.79 330.71L524.79 337.65L526.25 335.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.34 68.46C520.993 68.46 530.44 59.0132 530.44 47.36C530.44 35.7068 520.993 26.26 509.34 26.26C497.687 26.26 488.24 35.7068 488.24 47.36C488.24 59.0132 497.687 68.46 509.34 68.46Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.59 43.03C531.59 44.38 531.25 47.03 531.25 47.03H508.59L497.59 42.03V23.93C497.583 23.3786 497.763 22.8413 498.101 22.4054C498.439 21.9696 498.914 21.661 499.45 21.53C502.443 20.7381 505.503 20.226 508.59 20C511.613 20 514.606 20.5959 517.399 21.7536C520.191 22.9114 522.728 24.6082 524.864 26.7471C527 28.8861 528.694 31.4251 529.848 34.2191C531.002 37.013 531.594 40.0071 531.59 43.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.09 422.53V357.53H484.67V422.53H492.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.39 357.53V54.53H486.67V357.29L489.39 357.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.39 374.53V47.53H525.67V374.27L528.39 374.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.39 350.53V170.7C519.39 169.34 518.71 167.08 517.58 166.33L512.58 163.03V166.03L514.09 166.95C514.874 167.433 515.522 168.108 515.972 168.911C516.422 169.714 516.659 170.619 516.66 171.54V350.39L519.39 350.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.09 418.53V413.53H479.67V418.53H489.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.09 413.53V410.53H480.67V413.53H482.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.09 413.53V410.53H483.67V413.53H485.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4 442.35H436.09V451.53H506.4V442.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.4 503.35H437.09V512.53H507.4V503.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.73 298.04H252.69V359.83H258.73V298.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63 361.85H220.45V365.88H244.63V361.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18 430C242.53 437.72 252.27 437.47 254.96 430.16L256.22 425.29",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18 430C242.53 437.72 252.27 437.47 254.96 430.16L256.22 425.29",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.09 534.27H240.09L240.18 428.65L225.09 428.53V534.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93 534.44L236.74 428.65H225.09V534.35L236.93 534.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.96 424.98H220.45V429.01H243.96V424.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.42 365.21H205V425.66H261.42V365.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41 369.24H207.69V422.3H259.41V369.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67 412.53C221.609 413.795 221.179 415.014 220.432 416.036C219.685 417.059 218.655 417.84 217.469 418.282C216.282 418.725 214.992 418.809 213.758 418.526C212.524 418.242 211.401 417.603 210.527 416.687C209.652 415.771 209.066 414.619 208.841 413.373C208.615 412.127 208.76 410.842 209.258 409.678C209.755 408.514 210.583 407.521 211.64 406.823C212.696 406.125 213.934 405.752 215.2 405.75C216.957 405.792 218.625 406.53 219.838 407.801C221.051 409.072 221.71 410.773 221.67 412.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.09 412.53C235.024 413.794 234.588 415.01 233.838 416.028C233.087 417.047 232.054 417.823 230.867 418.261C229.68 418.698 228.391 418.778 227.159 418.491C225.927 418.203 224.806 417.561 223.935 416.643C223.064 415.725 222.482 414.572 222.26 413.326C222.038 412.081 222.185 410.798 222.685 409.635C223.185 408.473 224.014 407.482 225.071 406.787C226.128 406.091 227.365 405.72 228.63 405.72C230.389 405.77 232.056 406.515 233.267 407.791C234.478 409.067 235.133 410.771 235.09 412.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53 412.53C248.466 413.795 248.031 415.013 247.281 416.033C246.53 417.054 245.497 417.831 244.309 418.27C243.121 418.708 241.83 418.789 240.597 418.501C239.364 418.212 238.242 417.569 237.371 416.649C236.5 415.73 235.918 414.575 235.698 413.328C235.477 412.08 235.627 410.796 236.13 409.633C236.632 408.471 237.465 407.481 238.524 406.787C239.584 406.094 240.824 405.726 242.09 405.73C243.843 405.772 245.507 406.507 246.718 407.775C247.929 409.042 248.588 410.738 248.55 412.49L248.53 412.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.17 412.45C219.17 413.186 218.952 413.905 218.544 414.517C218.135 415.129 217.554 415.605 216.874 415.887C216.194 416.169 215.446 416.242 214.725 416.099C214.003 415.955 213.34 415.601 212.82 415.081C212.3 414.56 211.945 413.898 211.802 413.176C211.658 412.454 211.732 411.706 212.014 411.027C212.295 410.347 212.772 409.766 213.384 409.357C213.995 408.948 214.715 408.73 215.45 408.73C216.437 408.73 217.383 409.122 218.081 409.82C218.779 410.517 219.17 411.464 219.17 412.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6 412.45C232.6 413.186 232.382 413.906 231.973 414.518C231.563 415.13 230.982 415.607 230.301 415.888C229.621 416.169 228.873 416.242 228.151 416.098C227.429 415.954 226.766 415.598 226.246 415.077C225.726 414.556 225.373 413.892 225.23 413.17C225.088 412.448 225.163 411.699 225.446 411.02C225.729 410.34 226.208 409.76 226.821 409.352C227.434 408.945 228.154 408.728 228.89 408.73C229.875 408.733 230.819 409.126 231.514 409.823C232.21 410.521 232.6 411.465 232.6 412.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.09 412.45C246.09 413.186 245.872 413.905 245.463 414.517C245.055 415.129 244.474 415.605 243.794 415.887C243.114 416.169 242.366 416.242 241.645 416.099C240.923 415.955 240.26 415.601 239.74 415.081C239.22 414.56 238.865 413.898 238.722 413.176C238.578 412.454 238.652 411.706 238.934 411.027C239.215 410.347 239.692 409.766 240.304 409.357C240.915 408.948 241.635 408.73 242.37 408.73C243.356 408.733 244.301 409.126 244.998 409.823C245.695 410.52 246.088 411.464 246.09 412.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37 373.27H256.72C257.076 373.27 257.416 373.411 257.668 373.663C257.919 373.914 258.06 374.255 258.06 374.61V402.15C258.06 402.506 257.919 402.846 257.668 403.098C257.416 403.349 257.076 403.49 256.72 403.49H210.37C210.015 403.49 209.674 403.349 209.423 403.098C209.171 402.846 209.03 402.506 209.03 402.15V374.61C209.03 374.255 209.171 373.914 209.423 373.663C209.674 373.411 210.015 373.27 210.37 373.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72 375.95H211.72V400.8H256.72V375.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.01 359.83H260.75C260.927 359.83 261.102 359.865 261.265 359.933C261.428 360.001 261.576 360.101 261.701 360.226C261.826 360.352 261.924 360.5 261.991 360.664C262.058 360.828 262.091 361.003 262.09 361.18V363.86C262.09 364.216 261.949 364.558 261.698 364.811C261.447 365.064 261.106 365.207 260.75 365.21H252.01C251.654 365.207 251.313 365.064 251.062 364.811C250.811 364.558 250.67 364.216 250.67 363.86V361.18C250.669 361.003 250.702 360.828 250.769 360.664C250.836 360.5 250.934 360.352 251.059 360.226C251.183 360.101 251.332 360.001 251.495 359.933C251.658 359.865 251.833 359.83 252.01 359.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.03 289.98H259.4C259.753 289.979 260.104 290.048 260.431 290.182C260.758 290.317 261.055 290.515 261.305 290.765C261.555 291.015 261.753 291.312 261.888 291.639C262.023 291.966 262.091 292.317 262.09 292.67V296.03C262.09 296.383 262.02 296.732 261.885 297.058C261.75 297.384 261.551 297.68 261.301 297.929C261.051 298.178 260.755 298.375 260.428 298.509C260.102 298.643 259.753 298.712 259.4 298.71H254.03C253.318 298.71 252.635 298.428 252.131 297.926C251.627 297.424 251.342 296.742 251.34 296.03V292.67C251.34 291.957 251.623 291.273 252.128 290.768C252.632 290.264 253.316 289.98 254.03 289.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.09 293.53H220.16H251.09Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.09 293.53H220.16",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36 277.45V309.01V277.45Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36 277.45V309.01",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.99 280.22V306.41V280.22Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.99 280.22V306.41",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58 283.62V303.18V283.62Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58 283.62V303.18",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.3 287.69V300.58V287.69Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.3 287.69V300.58",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27 290.38V296.71V290.38Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.27 290.38V296.71",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53 291.72V295.58V291.72Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53 291.72V295.58",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.51 563.62H478.54V627.42H473.5V605.13L473.37 605.07V547.72H473.57L473.56 553.71L488.74 550.78L478.51 552.78V563.62Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.37 605.07L473.5 605.13V627.42H473.37V605.07Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.77 560.82V588.85L488.29 586.37L484.57 592.14V562.35L491.77 560.82Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.191 547.72V627.42H498.151V559.39L478.541 563.62H478.511V552.78L488.741 550.78L473.561 553.71L473.571 547.72H503.191Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.031 536.96L503.011 540.44L502.971 547.72V548.03L498.181 548.95L488.741 550.78L473.561 553.71L473.571 547.72L473.591 540.97V538.43L473.601 536.96H503.031Z",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.181 548.92V559.38L498.151 559.39L478.541 563.62H478.511V552.78L488.741 550.78L498.181 548.92Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.77 560.82V588.85L488.29 586.37L484.57 592.14V562.35L491.77 560.82Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.97 627.53V711.09H473.58V627.65V627.42L478.58 627.61V636.72V663.93L479.95 664.3V627.7V663.7L483.85 665.36L484.9 665.8L484.98 665.66L485.39 664.94H485.69L490.69 665.15H491.29L491.53 665.35L491.91 665.65L495.91 663.92L496.03 663.68L496.25 663.23L496.6 629.23V663.65L498.09 663.14V627.53H502.97Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.011 627.65V711.2H473.511V707.82V702.58V696.63L473.501 691.37V675.4L473.471 627.68H478.531L478.541 636.75L478.571 663.96L479.941 664.33L483.891 665.37L484.021 665.41L485.011 665.67L488.261 666.53L491.621 665.39L495.971 663.91L496.091 663.87L496.661 663.68L498.151 663.17L498.201 663.16V627.65H503.011Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.5 605.13V553.71",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.94 602.63V664.33L478.57 663.96L478.54 636.75V602.63H479.94Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.54 691.77V636.75",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.54 563.62V563.56",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.15 603.79V627.42V627.56V663.17L496.66 663.68V629.26V604.43",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.15 691.61V663.17",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.15 559.39V559.38",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.54 602.63H478.53",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.94 664.33V686.67H484.79V691.71",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.66 663.68V686.67H491.83V691.55",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.66 604.43V602.65H498.15",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.131 599.11V627.42H485.511V600.22L488.391 596.37L491.131 599.11Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.05 627.63V634.81H484.54V627.59H485.51V627.42H491.13V627.63H492.05Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.31 635.99L480.03 639.79V663.94L484.12 665.69",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.38 635.99L496.66 639.79V663.94L492.57 665.69",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.91 653.71L480.58 655.13",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.78 653.71L496.09 655.13",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.971 679.67H484.971",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.58 679.67H496.58",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.8 682.87C491.8 683.558 491.596 684.231 491.213 684.803C490.831 685.376 490.287 685.822 489.652 686.085C489.016 686.349 488.316 686.417 487.641 686.283C486.966 686.149 486.346 685.817 485.859 685.331C485.372 684.844 485.041 684.224 484.907 683.549C484.772 682.874 484.841 682.174 485.105 681.538C485.368 680.902 485.814 680.359 486.386 679.977C486.959 679.594 487.632 679.39 488.32 679.39C488.777 679.389 489.23 679.478 489.653 679.652C490.076 679.827 490.46 680.083 490.783 680.406C491.107 680.73 491.363 681.114 491.538 681.537C491.712 681.96 491.801 682.413 491.8 682.87Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.831 662.68C491.83 663.145 491.735 663.605 491.553 664.033C491.371 664.46 491.105 664.847 490.771 665.17C490.195 665.726 489.444 666.066 488.647 666.132C487.849 666.198 487.053 665.986 486.393 665.532C485.734 665.078 485.252 664.41 485.028 663.642C484.805 662.873 484.854 662.051 485.168 661.314C485.481 660.578 486.04 659.972 486.749 659.601C487.458 659.229 488.273 659.113 489.057 659.274C489.842 659.435 490.546 659.862 491.051 660.482C491.557 661.103 491.832 661.88 491.831 662.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.511 691.38L445.511 694.53L473.511 696.63V691.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.511 702.58L445.511 705.73L473.511 707.83V702.58Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.09 702.58L531.09 705.73L503.09 707.83V702.58Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.09 691.38L531.09 694.53L503.09 696.63V691.38Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.61 536.85H472.12V538.43H473.61V536.85Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 536.85H483.32V538.43H484.81V536.85Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.381 536.85H491.891V538.43H493.381V536.85Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.85 536.85H503.36V538.43H504.85V536.85Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.93 529.67H503.44V531.25H504.93V529.67Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.47 529.67H491.98V531.25H493.47V529.67Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 529.59H483.32V531.17H484.81V529.59Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.69 529.76H472.2V530.17H473.69V529.76Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.071 531.16V536.83H471.521L471.491 534.03L471.471 532.28V532.04H476.151L476.621 531.16H505.071Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.42 534.03L505.13 534.09",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.34 532.92V428.53H482.67V532.84L494.34 532.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.09 328.53V158.53H503.67V328.4L512.09 328.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.09 226.53V217.53H490.09V226.53H495.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.09 157.53V61.53H505.09V157.45L510.09 157.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.09 225.53V216.53H481.09V225.53H486.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.09 231.53V225.53H482.09V231.53H486.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.09 332.53V328.53H497.67V332.53H517.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.09 353.53V337.53H514.09V353.53H529.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.09 397.53V374.53H526.09V397.53H530.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.09 395.53V375.53H514.09V395.53H526.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 419.53V335.53H499.09V419.46L514.09 419.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.09 423.53V419.53H498.09V423.53H516.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.09 335.53V332.53H498.09V335.53H516.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.09 365.95V365.53H514.09V365.95H532.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.09 390.06V387.53H483.09V390.06H493.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.09 376.71V371.53H480.09V376.7L484.09 376.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.09 427.53V422.53H478.67V427.53H498.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 454.41H511.91V455.18H514.09V454.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 448.64H511.91V449.41H514.09V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 444.23H511.91V445H514.09V444.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 438.32H511.91V439.09H514.09V438.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.14 438.28H501.96V439.05H504.14V438.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.14 444.18H501.96V444.95H504.14V444.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.02 448.64H501.84V449.41H504.02V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.65 454.36H502.08V455.13H502.65V454.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.021 438.21H511.891V455.48L508 455.5L505.581 455.51H504.021V453.1V452.85V438.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.99 455.53L508.08 438.17",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 515.41H511.91V516.18H514.09V515.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 509.64H511.91V510.41H514.09V509.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 505.23H511.91V506H514.09V505.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 499.32H511.91V500.09H514.09V499.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.14 499.28H501.96V500.05H504.14V499.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.14 505.18H501.96V505.95H504.14V505.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.02 509.64H501.84V510.41H504.02V509.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.65 515.36H502.08V516.13H502.65V515.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.021 499.21H511.891V516.48L508 516.5L505.581 516.51H504.021V514.1V513.85V499.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.99 516.53L508.08 499.17",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.581 491.96H478.561V494.53H479.581V491.96Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.23 491.96H486.21V494.53H487.23V491.96Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.081 491.96H492.061V494.53H493.081V491.96Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.9 491.96H499.88V494.53H500.9V491.96Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.96 472.97H499.94V475.82H500.96V472.97Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.14 472.97H492.12V475.82H493.14V472.97Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.23 472.81H486.21V475.66H487.23V472.81Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.64 473.53H478.62V474.71H479.64V473.53Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.05 475.55V491.92H478.16L478.14 483.84L478.12 478.8V475.55H481.32H481.64H501.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.09 483.83L501.09 484.01L478.09 483.83Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.09 483.83L501.09 484.01",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.02 514.41H426.84V515.18H429.02V514.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.02 508.64H426.84V509.41H429.02V508.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.02 504.23H426.84V505H429.02V504.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.02 498.32H426.84V499.09H429.02V498.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.97 498.28H436.79V499.05H438.97V498.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.97 504.18H436.79V504.95H438.97V504.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.09 508.64H436.91V509.41H439.09V508.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.86 514.36H438.29V515.13H438.86V514.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.921 512.85V513.1V515.51H435.351L432.931 515.5L429.051 515.48V498.21H436.921V512.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.84 498.17L432.93 515.53",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.02 514.41H461.84V515.18H464.02V514.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.02 508.64H461.84V509.41H464.02V508.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.02 504.23H461.84V505H464.02V504.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.02 498.32H461.84V499.09H464.02V498.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.97 498.28H471.79V499.05H473.97V498.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.97 504.18H471.79V504.95H473.97V504.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.09 508.64H471.91V509.41H474.09V508.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.86 514.36H473.29V515.13H473.86V514.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.921 512.85V513.1V515.51H470.351L467.931 515.5L464.051 515.48V498.21H471.921V512.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.84 498.17L467.93 515.53",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.02 454.41H427.84V455.18H430.02V454.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.02 448.64H427.84V449.41H430.02V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.02 444.23H427.84V445H430.02V444.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.02 438.32H427.84V439.09H430.02V438.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.97 438.28H437.79V439.05H439.97V438.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.97 444.18H437.79V444.95H439.97V444.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.09 448.64H437.91V449.41H440.09V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.86 454.36H439.29V455.13H439.86V454.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.921 452.85V453.1V455.51H436.351L433.931 455.5L430.051 455.48V438.21H437.921V452.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84 438.17L433.93 455.53",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.02 454.41H462.84V455.18H465.02V454.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.02 448.64H462.84V449.41H465.02V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.02 444.23H462.84V445H465.02V444.23Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.02 438.32H462.84V439.09H465.02V438.32Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.97 438.28H472.79V439.05H474.97V438.28Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.97 444.18H472.79V444.95H474.97V444.18Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.09 448.64H472.91V449.41H475.09V448.64Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.86 454.36H474.29V455.13H474.86V454.36Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.921 452.85V453.1V455.51H471.351L468.931 455.5L465.051 455.48V438.21H472.921V452.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.84 438.17L468.93 455.53",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.77 520.29C471.237 520.29 478.1 513.427 478.1 504.96C478.1 496.493 471.237 489.63 462.77 489.63C454.304 489.63 447.44 496.493 447.44 504.96C447.44 513.427 454.304 520.29 462.77 520.29Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.771 520.26V489.66",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.471 504.96H478.061",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.77 462.29C446.237 462.29 453.1 455.427 453.1 446.96C453.1 438.493 446.237 431.63 437.77 431.63C429.304 431.63 422.44 438.493 422.44 446.96C422.44 455.427 429.304 462.29 437.77 462.29Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.771 462.26V431.66",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.471 446.96H453.061",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.09 422.53V380.53H499.72C498.93 380.529 498.165 380.803 497.556 381.305C496.947 381.807 496.531 382.505 496.38 383.28L491.25 409.64C490.87 411.64 489.14 416.03 487.13 416.03H482.13C481.18 416.03 477.52 418.73 477.37 420.09L477.09 422.53H504.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.19 65.5301C516.843 65.5301 526.29 56.0833 526.29 44.4301C526.29 32.7769 516.843 23.3301 505.19 23.3301C493.537 23.3301 484.09 32.7769 484.09 44.4301C484.09 56.0833 493.537 65.5301 505.19 65.5301Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.19 60.2601C513.933 60.2601 521.02 53.1728 521.02 44.4301C521.02 35.6874 513.933 28.6001 505.19 28.6001C496.448 28.6001 489.36 35.6874 489.36 44.4301C489.36 53.1728 496.448 60.2601 505.19 60.2601Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.191 51.82C509.272 51.82 512.581 48.5114 512.581 44.43C512.581 40.3487 509.272 37.04 505.191 37.04C501.109 37.04 497.801 40.3487 497.801 44.43C497.801 48.5114 501.109 51.82 505.191 51.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.191 50.2301C508.394 50.2301 510.991 47.6334 510.991 44.4301C510.991 41.2269 508.394 38.6301 505.191 38.6301C501.987 38.6301 499.391 41.2269 499.391 44.4301C499.391 47.6334 501.987 50.2301 505.191 50.2301Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.19 46.5401C506.355 46.5401 507.3 45.5954 507.3 44.4301C507.3 43.2647 506.355 42.3201 505.19 42.3201C504.025 42.3201 503.08 43.2647 503.08 44.4301C503.08 45.5954 504.025 46.5401 505.19 46.5401Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_91225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovCoreLiftController);
export default __webpack_public_path__ + "static/media/nov-core-lift-controller.962f0cb02ba87d1c0d66598d94449c37.svg";
export { ForwardRef as ReactComponent };